import React from "react";
import Card from "components/card";
import { FileText } from "lucide-react";
import DocumentCard from "./DocumentCard";

const MyDocuments = ({ documents = [] }) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                <h4 className="leading-none flex items-center gap-2 title-text">
                    <FileText className="w-5 h-5 text-emerald-600 dark:text-emerald-500" />
                    My Documents
                </h4>
                <p className="muted-text">
                    Access your employment documents
                </p>
            </div>
            <div className="px-6 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {documents.map((doc, index) => (
                        <DocumentCard 
                            key={index}
                            title={doc.title}
                            date={doc.date}
                            type="PDF"
                        />
                    ))}
                </div>
            </div>
        </Card>
    )
};
export default MyDocuments;